export const APP_NAME = 'NeoOne Inc.'
export const PERSIST_STORE_NAME = 'NeoCortex'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const UI_VERSION = "0.0.12"